import { useEffect, useState } from 'react';

import { useAppSelector } from 'app/hooks';
import { TTS_BUSINESS_API_ALERT_SKIPPED_KEY } from 'constants/storage-constants';

import type { TTSBusinessAPIPermissionsType } from 'model/types/permissions';

export const getTTSBusinessAPIAlertSkippedKey = (merchantId?: string) => `${TTS_BUSINESS_API_ALERT_SKIPPED_KEY}-${merchantId ?? 'default'}`;

const readSkippedPreference = (merchantId?: string) =>
  globalThis.localStorage.getItem(getTTSBusinessAPIAlertSkippedKey(merchantId)) === 'true';

export default function useTTSBusinessAPIPermissions(): TTSBusinessAPIPermissionsType {
  const merchant = useAppSelector((store) => store.merchant.merchant);

  const [skipped, setSkipped] = useState(() => readSkippedPreference(merchant?.id));

  // The merchant loads asynchronously: the lazy initializer may run before the id is
  // known, so re-derive the per-merchant preference once it arrives (or changes).
  useEffect(() => {
    setSkipped(readSkippedPreference(merchant?.id));
  }, [merchant?.id]);

  const handleGrantTTSBusinessAPIPermissions = () => globalThis.open(merchant?.tiktokBusinessAuthUrl, '_self');

  const handleSkipTTSBusinessAPIAlert = () => {
    if (merchant?.hidePlans) return;

    globalThis.localStorage.setItem(getTTSBusinessAPIAlertSkippedKey(merchant?.id), 'true');
    setSkipped(true);
  };

  return { merchant, skipped, handleGrantTTSBusinessAPIPermissions, handleSkipTTSBusinessAPIAlert };
}
